import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import useToast from '../../../hooks/useToast';
import { api } from '../../../services/api';
import { TitleHeader, SearchResult } from './styles';
import Button from '../../Button';
import { documentsService, fetchDocumentShareLink } from '../../../services/documents.service';
import ModalViewer, { ModalHandle } from '../ModalDocumentViewer';

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  locationId: string;
  locationName: string;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    maxWidth: '90%',
    maxHeight: '80vh',
    padding: '20px',
    borderRadius: '8px',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column' as any,
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 110,
  },
};

const ModalListDocuments: React.FC<ModalProps> = ({ isOpen, setIsOpen, locationId, locationName }) => {
  const { errorToast, successToast } = useToast();
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const viewerRef = React.useRef<ModalHandle>(null);

  useEffect(() => {
    if (isOpen && locationId) {
      loadDocuments();
    }
  }, [isOpen, locationId]);

  const loadDocuments = async () => {
    try {
      setLoading(true);
      const res = await api.get('/documents/global-search', {
        params: {
          physicalLocation: locationId,
          perPage: 1000
        }
      });
      setDocuments(res.data?.data || []);
    } catch (err: any) {
      errorToast('Erro ao carregar documentos da caixa');
    } finally {
      setLoading(false);
    }
  };

  const handleUnlink = async (docId: string) => {
    try {
      if (window.confirm("Deseja realmente desvincular este documento desta caixa física?")) {
        await documentsService.updateDocument(docId, { physicalLocation: null as any });
        successToast('Documento desvinculado!');
        loadDocuments();
      }
    } catch (err) {
      errorToast('Erro ao desvincular documento');
    }
  };

  const buildPath = (doc: any) => {
    if (doc.ancestors && Array.isArray(doc.ancestors) && doc.ancestors.length > 0) {
      const sorted = [...doc.ancestors].sort((a, b) => b.depth - a.depth);
      return '/' + sorted.map(a => a.name).join('/');
    }
    return doc.path || '/';
  };

  const handleOpenDocument = async (docId: string) => {
    try {
      const data = await fetchDocumentShareLink(docId);
      if (data.success && data.shareLink) {
        viewerRef.current?.openModal(data.shareLink, data.document);
      } else {
        errorToast('Erro ao obter link do documento');
      }
    } catch (err) {
      errorToast('Erro ao abrir documento');
    }
  };

  return (
    <>
    <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} style={customStyles} ariaHideApp={false}>
      <TitleHeader>
        <h3 style={{ color: '#333' }}>Conteúdo: {locationName}</h3>
        <button onClick={() => setIsOpen(false)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#333' }}>X</button>
      </TitleHeader>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {loading ? (
          <p style={{ color: '#333' }}>Carregando documentos...</p>
        ) : documents.length > 0 ? (
          documents.map(doc => (
            <SearchResult key={doc._id}>
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <strong style={{ color: '#111' }}>{doc.name}</strong>
                <div style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={buildPath(doc)}>
                  Pasta: {buildPath(doc)}
                </div>
              </div>
              <div style={{ marginLeft: '10px', display: 'flex', gap: '8px' }}>
                <Button label="Abrir" color="primary" variantType="small" onClick={() => handleOpenDocument(doc._id)} />
                <Button label="Desvincular" color="error" variantType="small" onClick={() => handleUnlink(doc._id)} />
              </div>
            </SearchResult>
          ))
        ) : (
          <p style={{ color: '#888', textAlign: 'center', marginTop: '20px' }}>Nenhum documento guardado neste local físico.</p>
        )}
      </div>
    </Modal>
    <ModalViewer ref={viewerRef} />
    </>
  );
};

export default ModalListDocuments;
